import { Button } from "@mui/material";

export function CtaButton({ href, children }: { href: string; children: string }) {
  return (
    <Button
      variant="contained"
      href={href}
      target="_blank"
      sx={{
        fontSize: { xs: "14px", sm: "16px" },
        fontWeight: "bold",
        textTransform: "uppercase",
      }}
    >
      {children}
    </Button>
  );
}
